import React from "react";
import styles from "./style.module.scss";
import { Image } from "@src/components/Image";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { openInstallmentUtil } from "../OverviewContent/utility";
import { getAwsAssets } from "@src/utils";
import { newWebEngage } from "@src/utils/webEngageEvent";
import DashBorder from "@src/components/UIElements/DashBorder";
import toast from "react-hot-toast";

const PayInstallments = () => {
  const { t } = useTranslation();
  const selectedState = useSelector(
    (state) => state?.overviewReducer?.stateSelected
  );
  const overViewData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course);
  const paymentData = useSelector(
    (state) => state?.overviewReducer);
  const courseDetails = useSelector((state) => {
    return state?.overviewReducer?.overViewDetails?.course;
  });
  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );
  // console.log(paymentData);
  const handleInstallmentCardClick = () => {
    if (courseDetails?.metaData?.isPhysicalDeliveryEnabled && !activeAddress) {
      toast.error("Please select address first", { duration: 3000 });
      return;
    }
    // let newDeeplink = { ...data?.installmentData?.deeplink };
    // if (selectedState) {
    // let newUrl = new URL(newDeeplink.paramOne);
    // newUrl.searchParams.append("state", `${selectedState}`);
    // newDeeplink.paramOne = newUrl.toString();
    // }
    // console.log(newDeeplink, "newDeeplink");
    // // directDeepLink({}, "UTIL_WEBVIEW", false)(newDeeplink);
    // hitDeeplinkPerformAction(COMMON_DEEPLINK_ACTIONS.OPEN_WEBVIEW, newDeeplink, newDeeplink);
    newWebEngage("course_pay_via_installments", {
      course_name: `${overViewData?.details?.name}`,
      instalment_amount: Number(paymentData?.individualInstallmentData?.purchaseButton?.amount / 100),
      course_price: Number(paymentData?.individualInstallmentData?.courseInfo?.priceSummary?.coursePrice / 100),
      final_amount: Number(paymentData?.individualInstallmentData?.courseInfo?.priceSummary?.effectivePrice / 100),
      action: "Pay in instalments Click",
      item: [
        {
          item_id: courseDetails?.metaData?.id, 
          item_name: courseDetails?.details?.name, 
          item_category: courseDetails?.categoryList,
          price: courseDetails?.priceDetails?.coursePrice
        }
      ],
    });
    openInstallmentUtil(selectedState);
  };
  const data = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.installments
  );

  return (
    <div className={styles.PayInstallmentsContainer}>
      <DashBorder />
      <div
        className={styles.PayInstallments}
        onClick={() => {
          handleInstallmentCardClick();
        }}
      >
        <div className={styles.PayInstallments__Left}>
          <Image
            src={getAwsAssets("PaymentInstallmentPie.svg", "content")}
            alt="c"
            height={"46px"}
            width={"46px"}
            priority={true}
            loading="eager"
          />
        </div>
        <div className={styles.PayInstallments__Middle}>
          <div className={styles.PayInstallments__Middle__Heading}>
            {data?.installmentEmblem?.heading}
          </div>
          <div className={styles.PayInstallments__Middle__SubHeading}>
            {data?.installmentEmblem?.text}
          </div>
        </div>
        <div className={styles.PayInstallments__Right}>
          <Image
            src={getAwsAssets("RightNav.svg", "content")}
            alt="c"
            height={8}
            width={8}
          />
        </div>
      </div>
      <DashBorder />
    </div>
  );
};

export default PayInstallments;
